import { setState } from './helpers'

const groupMutations = {
  SET_GROUPS_MODEL: setState('groupsModel'),
  SET_PARENT_ATTRIBUTES: setState('parentAttributes'),
  SET_PARENT_ATTRIBUTE_PENDING: setState('parentAttributesPending'),
  SET_GROUPS: setState('groups'),
  SET_CUSTOMER_GROUPS: setState('customerGroups'),
  SET_PARENT_GROUPS: setState('parentGroups'),
  SET_GROUP: setState('group'),
  SET_CUSTOMER_GROUP: setState('customerGroup'),
  SET_INITIAL_PARENT_ATTRIBUTES: setState('initialParentAttributes')
}

export { groupMutations }
